const availableStatuses = {
  active: 'active',
  inactive: 'inactive',
};

const locationStatuses = Object.values(availableStatuses);

export { locationStatuses };
